import { render } from "./SuperAdminTenantDetails.vue?vue&type=template&id=23889986&scoped=true"
import script from "./SuperAdminTenantDetails.vue?vue&type=script&lang=js"
export * from "./SuperAdminTenantDetails.vue?vue&type=script&lang=js"

import "./SuperAdminTenantDetails.vue?vue&type=style&index=0&id=23889986&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23889986"]])

export default __exports__